// extracted by mini-css-extract-plugin
export default {"main":"NavLink-module__main___3_J-1","iconRight":"NavLink-module__iconRight___1II-V"};